import { Product } from "../../types/types";

export function isPerMetre(product: Product): boolean {
  return product.unitOfMeasure === "METRE";
}
